<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm"
        >
          Save
        </button>
      </div>
    </div>

    <div class="card-page">
      <!-- Button Code Editor per View -->
      <div class="icon-code-editor">
        <img
          src="@/assets/new-form-ui/code-editor.svg"
          @click="openModalCodeEditor"
        >
        <div class="tooltip-component">
          Code Editor
        </div>
      </div>
      <!-- Button Properties setup view -->
      <div
        :class="{'error-input' : $v.dataSetup.sorting.key.$error || $v.dataSetup.sorting.order.$error}"
        class="icon-setup-view"
        @click="openConfiguration"
      >
        <img
          src="@/assets/new-form-ui/setup.svg"
        >
        <div class="tooltip-component">
          Configuration
        </div>
      </div>

      <div class="card-page-content card-page-content-list-view">
        <div class="mobile-content">
          <div class="position-relative h-100">
            <div class="wrap-list-view">
              <!-- Header -->
              <div class="header-view">
                <img
                  src="@/assets/new-form-ui/hamburger-icon.svg"
                  width="20"
                  height="20"
                >
                <div
                  :class="{'error-input' : $v.dataSetup.title.$error}"
                  class="box-title"
                  @click="openModalTitle(true)"
                >
                  <p>
                    {{ dataSetup.title || '...' }}
                  </p>

                  <!-- Edit -->
                  <div
                    class="edit-or-delete"
                    @click.stop="openModalTitle(true)"
                  >
                    <div class="button">
                      <div
                        class="edit"
                        @click.stop="openModalTitle(true)"
                      >
                        <i class="fa fa-pencil-square-o" />
                        <div class="tooltip-component">Edit title</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Content -->
              <div class="content-view">
                <!-- Summary Block -->
                <j-skeleton-summary-block
                  v-if="isLoading"
                  :is-mobile="true"
                />
                <div
                  v-if="!isLoading"
                  class="wrap-summary-block"
                >
                  <draggable
                    v-model="dataSetup.summary_block"
                    :options="{
                      animation:300,
                    }"
                    style="display: flex;"
                  >
                    <div
                      v-for="(data, index) in dataSetup.summary_block"
                      :key="index"
                      :style="styleDivBlock(data)"
                      class="container-summary-block mobile sum-custom"
                    >
                      <div class="item-name">{{ data.name }}</div>

                      <!-- Edit or Delete -->
                      <div class="edit-or-delete">
                        <div class="button">
                          <!-- Edit -->
                          <div
                            class="edit"
                            @click="openConfigBlock(data, index)"
                          >
                            <i class="fa fa-pencil-square-o" />
                          </div>
                          <!-- Delete -->
                          <div
                            class="delete"
                            @click="deleteBlock(index)"
                          >
                            <i class="fa fa-trash" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <!-- Add Block -->
                  <div
                    class="add-block mobile"
                    @click="openConfigBlock(null, null)"
                  >
                    <img
                      :src="require('@/assets/icon/add.png')"
                      class="m__r--5"
                      height="15"
                      width="15">
                    Add Block
                  </div>
                </div>

                <!-- List Field -->
                <div class="list-field">
                  <div
                    v-if="!isLoading"
                    class="field"
                  >
                    <!-- Icon Field -->
                    <div
                      class="div-image"
                      @click="openModalField('icon')"
                    >
                      <img
                        v-if="dataSetup.urlImg && dataSetup.urlImg.includes('http')"
                        :src="dataSetup.urlImg"
                      >
                      <span v-else-if="dataSetup.urlImg">{ ... }</span>
                      <span v-else>Image</span>

                      <!-- Edit -->
                      <div
                        class="edit-or-delete"
                        @click="openModalField('icon')"
                      >
                        <div class="button">
                          <div
                            class="edit"
                            @click.stop="openModalField('icon')"
                          >
                            <i class="fa fa-pencil-square-o" />
                            <div class="tooltip-component">Edit icon</div>
                          </div>
                          <!-- Delete -->
                          <div
                            v-if="dataSetup.urlImg"
                            class="delete"
                            @click.stop="deleteField('icon')"
                          >
                            <i class="fa fa-trash" />
                            <div class="tooltip-component">Delete icon</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Fields -->
                    <div class="wrap-text">
                      <div class="d-flex align-items-center justify-content-between">
                        <!-- Field 1 -->
                        <div
                          :class="{'error-input' : $v.dataSetup.text_1.$error}"
                          class="field-1"
                          @click="openModalField('text_1')"
                        >
                          <span>{{ dataSetup.text_1 ? '{'+dataSetup.text_1+'}' : 'Field 1' }}</span>

                          <!-- Edit -->
                          <div
                            class="edit-or-delete"
                            @click.stop="openModalField('text_1')"
                          >
                            <div class="button">
                              <div
                                class="edit"
                                @click.stop="openModalField('text_1')"
                              >
                                <i class="fa fa-pencil-square-o" />
                                <div class="tooltip-component">Edit field</div>
                              </div>
                              <!-- Delete -->
                              <div
                                v-if="dataSetup.text_1"
                                class="delete"
                                @click.stop="deleteField('text_1')"
                              >
                                <i class="fa fa-trash" />
                                <div class="tooltip-component">Delete field</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Field 3 -->
                        <div
                          class="text-field"
                          @click="openModalField('text_3')"
                        >
                          <span>{{ dataSetup.text_3 ? '{'+dataSetup.text_3+'}' : 'Field 3' }}</span>

                          <!-- Edit -->
                          <div
                            class="edit-or-delete"
                            @click.stop="openModalField('text_3')"
                          >
                            <div class="button">
                              <div
                                class="edit"
                                @click.stop="openModalField('text_3')"
                              >
                                <i class="fa fa-pencil-square-o" />
                                <div class="tooltip-component">Edit field</div>
                              </div>
                              <!-- Delete -->
                              <div
                                v-if="dataSetup.text_3"
                                class="delete"
                                @click.stop="deleteField('text_3')"
                              >
                                <i class="fa fa-trash" />
                                <div class="tooltip-component">Delete field</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex align-items-center justify-content-between">
                        <!-- Field 2 -->
                        <div
                          class="field-2"
                          @click="openModalField('text_2')"
                        >
                          <span>{{ dataSetup.text_2 ? '{'+dataSetup.text_2+'}' : 'Field 2' }}</span>

                          <!-- Edit -->
                          <div
                            class="edit-or-delete"
                            @click.stop="openModalField('text_2')"
                          >
                            <div class="button">
                              <div
                                class="edit"
                                @click.stop="openModalField('text_2')"
                              >
                                <i class="fa fa-pencil-square-o" />
                                <div class="tooltip-component">Edit field</div>
                              </div>
                              <!-- Delete -->
                              <div
                                v-if="dataSetup.text_2"
                                class="delete"
                                @click.stop="deleteField('text_2')"
                              >
                                <i class="fa fa-trash" />
                                <div class="tooltip-component">Delete field</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Field 4 -->
                        <div
                          class="text-field"
                          @click="openModalField('text_4')"
                        >
                          <span>{{ dataSetup.text_4 ? '{'+dataSetup.text_4+'}' : 'Field 4' }}</span>

                          <!-- Edit -->
                          <div
                            class="edit-or-delete"
                            @click.stop="openModalField('text_4')"
                          >
                            <div class="button">
                              <div
                                class="edit"
                                @click.stop="openModalField('text_4')"
                              >
                                <i class="fa fa-pencil-square-o" />
                                <div class="tooltip-component">Edit field</div>
                              </div>
                              <!-- Delete -->
                              <div
                                v-if="dataSetup.text_4"
                                class="delete"
                                @click.stop="deleteField('text_4')"
                              >
                                <i class="fa fa-trash" />
                                <div class="tooltip-component">Delete field</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Skeleton -->
                  <div
                    v-for="index in 3"
                    :key="index"
                    class="field"
                  >
                    <div class="div-image" />
                    <div class="wrap-text">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="skeleton-field-1" />
                        <div class="skeleton-field" />
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="skeleton-field-2" />
                        <div class="skeleton-field" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal Title -->
            <modal-title-list-view
              v-if="isOpenModalTitle"
              :id="idModalTitle"
              :data="dataSetup.title"
              @close-modal="toggleModalTitle(false)"
              @submit="submitModalTitle"
            />

            <!-- Modal Field -->
            <modal-field-list-view
              v-if="isOpenModalField"
              :id="idModalField"
              :variable-options="variableOptionsColumn"
              :data-field="selectedField"
              @close-modal="toggleModalField(false)"
              @submit="submitModalField"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Delete View -->
    <div class="card-transparent m__t--15">
      <span
        v-if="formDetail.list_view"
        class="cursor-pointer"
        style="font-size: 14px"
        @click="deleteView('default')"
      >
        <i class="fa fa-trash"/> <small>Delete this view</small>
      </span>
    </div>

    <!-- Configuration -->
    <list-view-configuration
      v-if="isOpenConfiguration"
      :id="idConfiguration"
      :data-config="dataSetup"
      :list-function="listFunction"
      :variables="variableOptions"
      :variable-options="variableOptionsClass"
      :is-have-configuration="isHaveConfiguration"
      @delete-view="deleteView"
      @close-configuration="toggleConfiguration(false)"
      @submit="submitConfig"
    />

    <!-- Configuration Summary Block -->
    <summary-block-configuration
      v-if="isOpenConfigBlock"
      :id="idConfigBlock"
      :field-detail="selectedBlock"
      :variable-options="variableOptionsClass"
      :list-function="listFunction"
      :is-reduce-blur="true"
      @delete-configuration="deleteBlock"
      @close-configuration="toggleConfigurationBlock(false)"
      @submit-configuration="submitBlock"
    />

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      :is-reduce-blur="true"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Modal External Api -->
    <b-modal
      ref="modalExternalApi"
      :hide-header="true"
      :hide-footer="true"
      class="modal-external-api"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-external-api-field
        v-if="showModalExternalUrl"
      />
    </b-modal>

    <!-- Modal Code Editor -->
    <b-modal
      ref="modalCodeEditor"
      :hide-header="true"
      :hide-footer="true"
      class="modal-code-editor-wrap"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-code-editor
        v-if="showModalCodeEditor"
        :view-data="viewJsonData"
        view-title="List View"
        type="list_view"
        @close="closeModalCodeEditor"
        @update="updateViewByCode"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import draggable from 'vuedraggable';
// Mixins
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixSetupListView from '@/mixins/form-ui-v2/jMixSetupListView';
import jMixSetupSummaryBlock from '@/mixins/form-ui-v2/jMixSetupSummaryBlock';
import jMixCodeEditorPerView from '@/mixins/form-ui-v2/jMixCodeEditorPerView';
// Components
import jSkeletonSummaryBlock from '@/views/experience-manager-v2/loading/jSkeletonSummaryBlock';
import ListViewConfiguration from '@/views/experience-manager-v2/partials/configuration/ListViewConfiguration';
import SummaryBlockConfiguration from '@/views/experience-manager-v2/partials/configuration/SummaryBlockConfiguration';
import ModalTitleListView from '@/views/experience-manager-v2/popup/ModalTitleListView';
import ModalFieldListView from '@/views/experience-manager-v2/popup/ModalFieldListView';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import ModalExternalApiField from '@/views/experience-manager-v2/popup/ModalExternalApiField';
import ModalCodeEditor from '@/views/experience-manager-v2/popup/ModalCodeEditor';

export default {
  components: {
    draggable,
    jSkeletonSummaryBlock,
    ListViewConfiguration,
    SummaryBlockConfiguration,
    ModalTitleListView,
    ModalFieldListView,
    ModalFieldLibrary,
    ModalExternalApiField,
    ModalCodeEditor,
  },

  mixins: [jMixScroll, jMixToolbox, jMixSetupListView, jMixSetupSummaryBlock, jMixCodeEditorPerView],

  validations: {
    dataSetup: {
      title: { required },
      description: {},
      text_1: { required },
      text_2: { },
      text_3: { },
      text_4: { },
      config: { },
      sorting: {
        key: { required },
        order: { required },
      },
      filter: { },
      filter_function: { },
      filterOperator: { },
      search_options_list: { },
      summary_block: { },
    },
  },

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        title: null,
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        config: {},
        urlImg: null,
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        search_options_list: [],
        summary_block: [],
      },
      variableOptions: [],
      variableOptionsClass: [],
      variableOptionsColumn: [],
      listFunction: [],
      api: JSON.parse(localStorage.getItem('Token')).value,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    genData() {
      const { title, text_1, text_2, text_3, text_4, config, urlImg, sorting, filter, filter_function, filterOperator, search_options_list, summary_block } = this.dataSetup;
      const datas = [text_1, text_2, text_3, text_4];
      const params = this._.cloneDeep(this.formDetail);
      params.list_view = {
        title,
        text_1: text_1 || null,
        text_2: text_2 || null,
        text_3: text_3 || null,
        text_4: text_4 || null,
        config: config || { columns: [] },
        icon: urlImg,
        sort: [],
        filter: {},
        filter_function: {},
        filter_operator: filterOperator,
        search_options_list,
        summary_block: summary_block.length > 0 ? summary_block : null,
      };

      // Set Config
      if (!params.list_view.config.columns) params.list_view.config.columns = [];
      if (params.list_view.config.columns.length === 0) {
        datas.forEach((data, index) => {
          if (data) {
            params.list_view.config.columns.push({
              field: `text_${index + 1}`,
              key: data,
              type: 'text',
            });
          }
        });
      }
      params.list_view.config = this.sortConfig(params.list_view.config);

      params.list_view.sort.push({
        [sorting.key.id]: sorting.order.id === 'asc' ? 1 : -1,
      });
      if (filter.length > 0) {
        filter.forEach((e) => {
          if (e.key) {
            params.list_view.filter[e.key.id] = e.value;
          }
        });
      }
      if (filter_function.length > 0) {
        filter_function.forEach((e) => {
          if (e.key) {
            params.list_view.filter_function[e.key.id] = e.value;
          }
        });
      }
      return params;
    },

    isHaveConfiguration() {
      return !!this.formDetail.list_view;
    },

    viewJsonData() {
      return JSON.stringify(this.formDetail.list_view, null, 4);
    },
  },

  watch: {
    form_data_detail(val) {
      if (val.length > 0) {
        this.setDetail(val[0].columns);
      }
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.actionGetDetailFormData(param);
      this.isLoading = false;
    } else if (this.formDetail.data_source.dataset && this.formDetail.data_source.dataset.dataset_id) {
      const req = {
        id: this.formDetail.data_source.dataset.dataset_id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        const detailDataset = res.data || null;
        this.isLoading = false;

        if (detailDataset) {
          this.setDetail(detailDataset.column);
        }
      });
    } else {
      await this.setExternalUrl();
      this.isLoading = false;
    }
    this.getListFunction();
  },

  methods: {
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup']),

    setDetail(columns) {
      const listColumns = Object.keys(columns);
      const listColumnsVal = Object.values(columns);

      this.variableOptions = [];
      this.variableOptionsClass = [];
      this.variableOptionsColumn = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            this.variableOptions.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsClass.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsColumn.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            if (listColumnsVal[index].type === 'person') {
              this.variableOptionsClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.variableOptionsClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.variableOptionsClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }

      if (this.formDetail.list_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.list_view));
        const { text_1, text_2, text_3, text_4, config, title, icon, search_options_list, summary_block } = data;
        this.dataSetup = {
          title,
          text_1: text_1 || null,
          text_2: text_2 || null,
          text_3: text_3 || null,
          text_4: text_4 || null,
          config: config || { columns: [] },
          urlImg: icon,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: search_options_list || [],
          summary_block: summary_block || [],
        };
        this.dataSetup.filterOperator = this.formDetail.list_view.filter_operator ?
          this.formDetail.list_view.filter_operator : null;

        // Set Config
        this.setDefaultConfigField(this.formDetail.list_view);

        const { sort, filter, filter_function } = this.formDetail.list_view;
        if (sort) {
          const keySort = Object.keys(sort[0]);
          const valueSort = Object.values(sort[0]);

          this.dataSetup.sorting = {
            key: { id: keySort[0] },
            order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
          };
        }

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }
      } else {
        this.dataSetup = {
          title: null,
          text_1: null,
          text_2: null,
          text_3: null,
          text_4: null,
          config: {},
          urlImg: null,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
          summary_block: [],
        };

        // Set Config
        this.setDefaultConfigField(this.formDetail.list_view);
      }
    },

    styleDivBlock(item) {
      return { '--color': item.color };
    },

    setExternalUrl() {
      const listColumns = Object.keys(this.formDetail.data_source.external_url.columns);
      const listColumnsVal = Object.values(this.formDetail.data_source.external_url.columns);

      this.variableOptions = [];
      this.variableOptionsClass = [];
      this.variableOptionsColumn = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            this.variableOptions.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsClass.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsColumn.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            if (listColumnsVal[index].type === 'person') {
              this.variableOptionsClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.variableOptionsClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.variableOptionsClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }

      if (this.formDetail.list_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.list_view));
        const { text_1, text_2, text_3, text_4, config, title, icon, search_options_list, summary_block } = data;
        this.dataSetup = {
          title,
          text_1: text_1 || null,
          text_2: text_2 || null,
          text_3: text_3 || null,
          text_4: text_4 || null,
          config: config || { columns: [] },
          urlImg: icon,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: search_options_list || [],
          summary_block: summary_block || [],
        };
        this.dataSetup.filterOperator = this.formDetail.list_view.filter_operator ?
          this.formDetail.list_view.filter_operator : null;

        // Set Config
        this.setDefaultConfigField(this.formDetail.list_view);

        const { sort, filter, filter_function } = this.formDetail.list_view;
        if (sort) {
          const keySort = Object.keys(sort[0]);
          const valueSort = Object.values(sort[0]);

          this.dataSetup.sorting = {
            key: { id: keySort[0] },
            order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
          };
        }

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }
      } else {
        this.dataSetup = {
          title: null,
          text_1: null,
          text_2: null,
          text_3: null,
          text_4: null,
          config: {},
          urlImg: null,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
          summary_block: [],
        };

        // Set Config
        this.setDefaultConfigField(this.formDetail.list_view);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jListView.vue